// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__190Jo","importantInfo":"styles_importantInfo__2v0Mh"};